import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 33"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M3.866 25.515 6.55 13.888a2.634 2.634 0 0 1 2.572-2.05H26.77V9.727c0-.872-.707-1.585-1.584-1.585h-12.17a.54.54 0 0 1-.413-.195l-1.479-1.85A1.56 1.56 0 0 0 9.888 5.5H4.585A1.59 1.59 0 0 0 3 7.085V26.1c0 .784.57 1.428 1.314 1.557a2.64 2.64 0 0 1-.448-2.143"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M29.327 13.492a1.58 1.58 0 0 0-1.242-.597H9.122c-.74 0-1.374.507-1.543 1.231L4.896 25.747c-.106.47.005.962.306 1.342s.756.597 1.242.597h18.958c.745 0 1.379-.502 1.548-1.226l2.678-11.62c.11-.476 0-.968-.301-1.348"
    }
  )
);
var SvgFolderOpenFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FolderOpenFilled_default = SvgFolderOpenFilled;

export { FolderOpenFilled_default as default };
